import { notesMigrationTypes } from "./notesMigrationTypes";
import { formatCustomDate } from "helpers/dateTools";

const {
  SET_NOTES_MIGRATION_FILTERS,
  GET_NOTES_MIGRATION,
  SELECT_NOTE_TO_MIGRATE,
  REMOVE_NOTES_SELECTION,
  DESELECT_NOTE_TO_MIGRATE,
  ERROR_NOTES_MIGRATION,
  DO_NOTES_MIGRATION,
  CLEAR_NOTES_MIGRATION,
  SET_CONFIG_FILTER_NOTES_MIGRATION,
  SET_CONFIG_PAGE_NOTES_MIGRATION,
  SET_CONFIG_PAGE_SIZE_NOTES_MIGRATION,
  SET_CONFIG_SORTED_NOTES_MIGRATION,
  UPDATE_NOTE_MIGRATION,
  TOGGLE_FIVE_PER_THOUSAND,
} = notesMigrationTypes

const INITIAL_STATE = {
  startDate: formatCustomDate(new Date(), '-'),
  endDate: formatCustomDate(new Date(), '-'),
  station: [],
  notesMigrationArr: [],
  notesToMigrate: new Map(),
  hasChecked: false,
  counter: 0,
  counterAmount: 0,
  config: {
    page: 0,
    pageSize: 20,
    filtered: [],
    sorted: []
  },
}

export const notesMigrationReducer = (state = INITIAL_STATE, { type, payload }) => {

  switch (type) {

    case SET_NOTES_MIGRATION_FILTERS:
      return {
        ...state,
        [payload.key]: payload.data,
      };

    case GET_NOTES_MIGRATION: {
      const mapData = payload.map(note => ({
        ...note,
        date: note?.date.split("T")[0],
        customerSlice: `${note?.customer.slice(0, 20)}...`,
        statusMigration: note?.statusMigration ? note.statusMigration : 'SIN_ENVIAR',
        checked: false,
        idInvoice: note?.idInvoice ? note.idInvoice : 'NO',
      }))

      // Nueva búsqueda: ninguna nota queda seleccionada, se reinicia el resumen
      return {
        ...state,
        notesMigrationArr: mapData,
        notesToMigrate: new Map(),
        hasChecked: false,
        counter: 0,
        counterAmount: 0,
      }
    }

    case SELECT_NOTE_TO_MIGRATE: {
      const selectNotes = state.notesMigrationArr.map(note =>
        note.id === payload
          ? { ...note, checked: !note.checked }
          : note
      )
      const hasChecked = selectNotes?.some(note => note?.checked)
      const { counting, countingAmount } = selectNotes.reduce(
      (acc, note) => {
        if (note.checked) {
          acc.counting += note.quantity;
          acc.countingAmount += note.total;
        }
        return acc;
      }, { counting: 0, countingAmount: 0 }
);
      return {
        ...state,
        notesMigrationArr: selectNotes,
        hasChecked: hasChecked,
        counter: counting,
        counterAmount: countingAmount
      }
    }

    case REMOVE_NOTES_SELECTION: {
      const notesMigrationArr = state.notesMigrationArr.map(note => ({
        ...note,
        checked: false
      }))
      return {
        ...state,
        notesMigrationArr: notesMigrationArr,
        notesToMigrate: new Map(),
        hasChecked: false,
        counter: 0,
        counterAmount: 0
      }
    }

    case DESELECT_NOTE_TO_MIGRATE: {
      const editedNotesToMigrate = state.notesToMigrate
      if (editedNotesToMigrate.has(payload)) editedNotesToMigrate.delete(payload)
      return {
        ...state,
        notesToMigrate: editedNotesToMigrate,
      }
    }

    case ERROR_NOTES_MIGRATION: {
      // ERROR_ENVIO es un status local: el envío falló antes de persistirse, en DB la nota sigue SIN_ENVIAR.
      // Se desmarca para que no se reenvíe sin que el usuario la vuelva a seleccionar.
      const migrationArrWithError = state.notesMigrationArr.map(note =>
        note?.id === payload
          ? { ...note, statusMigration: 'ERROR_ENVIO', checked: false }
          : note
      )
      const checkedWithError = migrationArrWithError.filter(note => note?.checked)

      const newNotesToMigrateDel = state.notesToMigrate
      newNotesToMigrateDel.delete(payload)

      return {
        ...state,
        notesMigrationArr: migrationArrWithError,
        notesToMigrate: newNotesToMigrateDel,
        hasChecked: checkedWithError.length > 0,
        counter: checkedWithError.reduce((acc, note) => acc + note.quantity, 0),
        counterAmount: checkedWithError.reduce((acc, note) => acc + note.total, 0),
      }
    }

    case DO_NOTES_MIGRATION: {
      const statusById = new Map(Object.values(payload).map(item => [item.id, item.status]))

      // Las notas enviadas se desmarcan para que un nuevo "migrar" no las reenvíe
      const newMigrationArr = state.notesMigrationArr.map(note =>
        statusById.has(note.id)
          ? { ...note, statusMigration: statusById.get(note.id), checked: false }
          : { ...note, checked: false }
      )
      return {
        ...state,
        notesMigrationArr: newMigrationArr,
        notesToMigrate: new Map(),
        hasChecked: false,
        counter: 0,
        counterAmount: 0,
      }
    }
    // Cancel o resend migration
    case UPDATE_NOTE_MIGRATION: {
      const mapNotesMigration = state.notesMigrationArr.map(item => item.id === payload.id ? { ...item, statusMigration: payload.status} : item)
      return {
        ...state,
        notesMigrationArr: mapNotesMigration
      }
    }

    case TOGGLE_FIVE_PER_THOUSAND: {
      const updatedNotes = state.notesMigrationArr.map(note =>
        note.id === payload
          ? { ...note, isFivePerThousand: !note.isFivePerThousand }
          : note
      )
      return {
        ...state,
        notesMigrationArr: updatedNotes,
      }
    }

    case CLEAR_NOTES_MIGRATION:
      return {
        ...state,
        ...INITIAL_STATE,
      };

    case SET_CONFIG_FILTER_NOTES_MIGRATION:
      return {
        ...state,
        config: {
          ...state.config,
          filtered: payload,
          page: 0,
        },
      };

    case SET_CONFIG_PAGE_NOTES_MIGRATION:
      return {
        ...state,
        config: {
          ...state.config,
          page: payload,
        },
      };

    case SET_CONFIG_PAGE_SIZE_NOTES_MIGRATION:
      return {
        ...state,
        config: {
          ...state.config,
          pageSize: payload,
          page: 0,
        },
      };

    case SET_CONFIG_SORTED_NOTES_MIGRATION:
      return {
        ...state,
        config: {
          ...state.config,
          sorted: payload,
          page: 0,
        }
      }

    default:
      return state
  }
}